module.exports = "https://www.gc-pro.gnp.com.mx/84b30a7e9300b7c3b905c2190eee3192.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Icono_SmartTrip_PSC_61X66a.svg
// module id = 8055
// module chunks = 0